export default __webpack_public_path__ + "static/media/cardPaymentApi.0b3c077a.yaml";